export default{
    API_ENDPOINT: 'https://sheltered-fortress-79630.herokuapp.com/api',
    TOKEN_KEY: 'logs-client-auth-token',
}